/* =====================================================================
   FRACAZ · Interior y correas: escena contada con el scroll.
   1. Llega desde la lluvia: la etiqueta FRACAZ, grande y nítida, un poco
      levantada; se asienta justo cuando la escena se queda fija.
   2. Un solo movimiento: la etiqueta se encoge hasta su sitio en la mochila
      mientras la foto del interior aparece alrededor (desde la etiqueta hacia
      fuera) y, a la vez, una aguja la cose con hilo (por encima de su propia
      costura). Al llegar, la etiqueta se funde con la de la foto.
   3. Entra el texto del interior, encima de la tapa azul.
   4. La tarjeta gira (como dar la vuelta a la mochila): por detrás, la foto
      de las correas (sin fondo, si es un PNG recortado) con su texto.
   La etiqueta va FUERA de la foto que hace zoom: se dibuja a su tamaño real
   en cada momento (con la «Foto de la etiqueta» en alta), así se ve nítida
   aunque empiece muy grande. Las costuras van dentro de ella.
   Mientras no gira, la tarjeta no lleva transformaciones 3D: el navegador
   repinta la foto a su tamaño real (con 3D la congelaba y se veía borrosa).
   Solo trabaja con la sección cerca de la pantalla. Con «reducir
   movimiento»: sin zoom, giro ni costura, solo fundidos.
   Fluidez en móvil: todo lo que se mueve por fotograma va con transform u
   opacity (la etiqueta tiene tamaño fijo y se escala; la mochila aparece
   con un velo del color del fondo que se agranda; las sombras se funden).
   Mientras hay scroll, la tarjeta va en su propia capa; al parar se repinta
   nítida. La costura va más despacio que el scroll si hace falta, para que
   siempre se vea entera.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__fzInside) return;
  window.__fzInside = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var scenes = [];
  var ticking = false;
  var uid = 0;
  var SVGNS = 'http://www.w3.org/2000/svg';

  // Tramos del recorrido fijo (0 → 1). Sin correas, la escena acaba tras el texto.
  // zoom: la etiqueta se encoge hasta su sitio · reveal: aparece la mochila alrededor
  // stitch: la aguja entra, cose y se va (a la vez que el zoom)
  var T_FULL = { zoom: [0.02, 0.48], reveal: [0.05, 0.36], stitch: [0, 0.4], textIn: [0.5, 0.58], flip: [0.65, 0.82], strapIn: [0.82, 0.9] };
  var T_SOLO = { zoom: [0.02, 0.62], reveal: [0.05, 0.44], stitch: [0, 0.5], textIn: [0.66, 0.78], flip: null, strapIn: null };
  // La costura persigue al scroll con este retardo (s) y, como mucho, a esta velocidad (tramo/s):
  // aunque se baje deprisa, la aguja tarda al menos ~1 s en dar la vuelta a la etiqueta
  var ST_LAG = 0.18, ST_MAX = 0.8;
  // La escena entera también va un pelín por detrás del scroll (suave aunque el scroll vaya a
  // tirones) y, como mucho, a esta velocidad (escena/s): un golpe de dedo no se la salta
  var P_LAG = 0.12, P_MAX = 0.45;
  // Velo de la aparición: el hueco nítido empieza en este % del radio del velo (el resto lo tapa)
  var VEIL_HOLE = 0.1;
  // Dentro del tramo de costura (0 → 1): entra la aguja, cose, se va
  var U_IN = 0.06, U_OUT = 0.88;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function seg(p, r) { return clamp((p - r[0]) / (r[1] - r[0]), 0, 1); }
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function smooth(t) { return t * t * (3 - 2 * t); }

  // Conexión lenta: con ella no se piden las versiones en alta (se queda la ligera)
  function slowNet() {
    var c = navigator.connection;
    if (c) {
      if (c.saveData) return true;
      if (/(^|-)2g|3g/.test(c.effectiveType || '')) return true;
      if (c.downlink && c.downlink < 1.5) return true;
    }
    try {
      var bytes = 0, ms = 0;
      performance.getEntriesByType('resource').forEach(function (e) {
        if (e.initiatorType === 'img' && e.encodedBodySize > 30000 && e.responseEnd > e.responseStart) {
          bytes += e.encodedBodySize;
          ms += e.responseEnd - e.responseStart;
        }
      });
      if (ms > 0 && bytes / ms < 150) return true; // menos de ~150 KB/s
    } catch (e) {}
    return false;
  }

  // Sustituye la foto por su versión en alta cuando ya está descargada (sin parpadeo)
  function upgradeImg(im, url, done) {
    if (!im || !url || im.__fzUp) return;
    im.__fzUp = true;
    var big = new Image();
    big.onload = function () {
      var swap = function () {
        im.removeAttribute('srcset');
        im.removeAttribute('sizes');
        im.src = url;
        if (done) done();
      };
      if (big.decode) big.decode().then(swap, swap);
      else swap();
    };
    big.src = url;
  }

  // Opacidad solo si cambia (evita recalcular estilos en cada fotograma)
  function setOpacity(el, v) {
    if (!el) return;
    var t = v.toFixed(3);
    if (el.__fzOp !== t) { el.__fzOp = t; el.style.opacity = t; }
  }

  function svgEl(tag, attrs, parent) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  // Color del hilo y sus tonos (el mismo color mezclado con blanco o con negro)
  function parseHex(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return [239, 230, 212];
    var n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function mix(c, w, a) {
    return 'rgb(' + c.map(function (v, i) { return Math.round(v + (w[i] - v) * a); }).join(',') + ')';
  }

  function parseBox(str, def) {
    var a = (str || '').split(',').map(parseFloat);
    if (a.length < 4 || a.some(isNaN) || a[2] <= 0 || a[3] <= 0) a = def;
    return { x: a[0] / 100, y: a[1] / 100, w: a[2] / 100, h: a[3] / 100 };
  }

  function setup(el) {
    if (el.__fzInside) return;
    el.__fzInside = true;
    var s = {
      el: el,
      pin: el.querySelector('.fz-inside__pin'),
      card: el.querySelector('[data-fz-inside-card]'),
      front: el.querySelector('[data-fz-inside-front]'),
      back: el.querySelector('[data-fz-inside-back]'),
      photo: el.querySelector('.fz-inside__img'),
      tag: el.querySelector('[data-fz-inside-tag]'),
      tagImg: null,
      tagLoaded: false,
      labelOk: false,
      veil: null,
      veilColor: '',
      moving: 0,
      hudText: '',
      text: el.querySelector('[data-fz-inside-text]'),
      strapText: el.querySelector('[data-fz-inside-strap-text]'),
      titles: el.querySelectorAll('.fz-inside__title, .fz-inside__strap-title'),
      facts: el.querySelector('[data-fz-inside-facts]'),
      hudBox: el.querySelector('.fz-inside__hud'),
      hud: el.querySelector('[data-fz-inside-hud]'),
      value: el.querySelector('[data-fz-inside-value]'),
      ar: parseFloat(el.getAttribute('data-ar')) || 0.75,
      strapAr: parseFloat(el.getAttribute('data-strap-ar')) || 0,
      cutout: el.hasAttribute('data-strap-cutout'),
      lab: parseBox(el.getAttribute('data-label'), [41.3, 38.33, 18.8, 8.25]),
      size: (parseFloat(el.getAttribute('data-label-size')) || 56) / 100,
      near: false,
      cb: { x0: 0, y0: 0, x1: 1, y1: 1 },
      geo: null,
      last: '',
      hudSide: '',
      pre: 0,
      // costura
      stitchOn: el.getAttribute('data-stitch') === 'true',
      st: null,
      uTarget: 0,
      uShown: 0,
      uTime: 0,
      stFade: 0,
      sewn: false,
      hudSew: false
    };
    if (!s.pin || !s.card || !s.front) return;
    s.T = s.back ? T_FULL : T_SOLO;
    // La etiqueta grande solo se usa cuando su foto ya ha llegado (si no, se ve la mochila entera)
    s.tagImg = s.tag ? s.tag.querySelector('img') : null;
    // Sombra de la etiqueta: dos capas fijas (apoyada y levantada) que se funden con opacity
    if (s.tag) {
      s.shRest = document.createElement('span');
      s.shLift = document.createElement('span');
      s.shRest.className = 'fz-inside__tag-sh fz-inside__tag-sh--rest';
      s.shLift.className = 'fz-inside__tag-sh fz-inside__tag-sh--lift';
      s.shRest.setAttribute('aria-hidden', 'true');
      s.shLift.setAttribute('aria-hidden', 'true');
      s.tag.insertBefore(s.shLift, s.tag.firstChild);
      s.tag.insertBefore(s.shRest, s.tag.firstChild);
    }
    if (s.tagImg) {
      var tagDone = function () {
        s.tagLoaded = s.tagImg.naturalWidth > 0;
        s.last = '';
        request();
      };
      if (s.tagImg.complete && s.tagImg.naturalWidth) s.tagLoaded = true;
      else s.tagImg.addEventListener('load', tagDone, { once: true });
    }
    // Velo para la aparición de la mochila (va dentro de la tarjeta, encima de la foto)
    if (s.tag && s.photo) {
      s.veil = document.createElement('div');
      s.veil.className = 'fz-inside__veil';
      s.veil.setAttribute('aria-hidden', 'true');
      var pic = s.photo.closest('picture') || s.photo;
      pic.parentNode.insertBefore(s.veil, pic.nextSibling);
    }
    if (s.hudBox) s.hudBox.style.transition = 'opacity 0.35s ease';
    if (s.stitchOn && s.tag) buildStitch(s);
    else s.stitchOn = false;

    // Las fotos se piden en cuanto la sección se acerca (primero la etiqueta, que es lo que se
    // ve al empezar); la foto del interior llega en versión ligera y, si la conexión va bien,
    // se cambia por la de alta al tener la escena cerca.
    var imgs = Array.prototype.slice.call(el.querySelectorAll('img[loading="lazy"]'));
    if (s.tagImg) imgs.sort(function (a, b) { return a === s.tagImg ? -1 : b === s.tagImg ? 1 : 0; });
    if (imgs.length) {
      new IntersectionObserver(function (entries, io) {
        if (!entries[0].isIntersecting) return;
        imgs.forEach(function (im) { im.loading = 'eager'; });
        io.disconnect();
      }, { rootMargin: '150% 0px 150% 0px' }).observe(el);
    }

    new IntersectionObserver(function (entries) {
      s.near = entries[0].isIntersecting;
      if (s.near) {
        // Al acercarse, la escena arranca donde está el scroll (sin animar desde otro punto)
        s.pS = undefined;
        s.pTime = 0;
        measure(s);
        s.last = '';
        request();
        if (s.photo && !slowNet()) {
          var hi = window.innerWidth < 750 ? (s.photo.getAttribute('data-fz-hires-m') || s.photo.getAttribute('data-fz-hires')) : s.photo.getAttribute('data-fz-hires');
          upgradeImg(s.photo, hi);
        }
      }
    }, { rootMargin: '30% 0px 30% 0px' }).observe(el);

    if (window.ResizeObserver) {
      new ResizeObserver(function () { measure(s); s.last = ''; request(); }).observe(s.pin);
    }

    scenes.push(s);
    measure(s);
    update(s);
    findContent(s);
    findLabel(s);
  }

  /* ---------- Costura ----------
     Un SVG encima de la etiqueta, en unidades de la etiqueta (1000 de ancho): agujeros,
     sombra del hilo, hilo (retorcido) y su brillo; las puntadas se dibujan con un
     stroke-dasharray que se rehace en cada fotograma (puntadas enteras hasta la aguja y la
     última a medias). Encima, el hilo suelto hasta el ojo de la aguja y la aguja. */
  function buildStitch(s) {
    var id = 'fzst' + (++uid);
    var col = parseHex(s.el.getAttribute('data-stitch-color'));
    var svg = svgEl('svg', { class: 'fz-inside__stitch', 'aria-hidden': 'true', focusable: 'false', preserveAspectRatio: 'none' });
    var defs = svgEl('defs', {}, svg);
    // Metal de la aguja: brillo a lo largo del eje, oscuro en los bordes
    var gr = svgEl('linearGradient', { id: id + 'm', x1: '0', y1: '0', x2: '0', y2: '1' }, defs);
    [['0', '#6e7176'], ['0.32', '#e9eaec'], ['0.46', '#ffffff'], ['0.62', '#c3c6ca'], ['1', '#5f6267']].forEach(function (st) {
      svgEl('stop', { offset: st[0], 'stop-color': st[1] }, gr);
    });
    var blur = svgEl('filter', { id: id + 'b', x: '-40%', y: '-200%', width: '180%', height: '500%' }, defs);
    svgEl('feGaussianBlur', { stdDeviation: '5' }, blur);
    var clip = svgEl('clipPath', { id: id + 'c' }, defs);
    var clipRect = svgEl('rect', { x: '0', y: '-80', width: '700', height: '160' }, clip);
    // Hilo retorcido: rayas en diagonal (en cualquier lado de la etiqueta se ven cruzadas)
    var tw = svgEl('pattern', { id: id + 't', width: '10', height: '10', patternUnits: 'userSpaceOnUse', patternTransform: 'rotate(40)' }, defs);
    svgEl('rect', { width: '10', height: '10', fill: mix(col, [255, 255, 255], 0) }, tw);
    svgEl('rect', { x: '0', width: '3', height: '10', fill: mix(col, [255, 255, 255], 0.55) }, tw);
    svgEl('rect', { x: '6', width: '2.2', height: '10', fill: mix(col, [60, 45, 25], 0.22) }, tw);

    var track = svgEl('path', { fill: 'none', stroke: 'none' }, svg);
    var line = { fill: 'none', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' };
    // Agujeros y sombra en tono cálido: el hilo crema se lee en relieve sobre la etiqueta crema
    var holes = svgEl('path', Object.assign({ stroke: 'rgba(70,52,28,0.36)', 'stroke-width': '12.5' }, line), svg);
    var shadow = svgEl('path', Object.assign({ stroke: 'rgba(70,52,28,0.5)', 'stroke-width': '10', transform: 'translate(0.8 3.2)' }, line), svg);
    var thread = svgEl('path', Object.assign({ stroke: 'url(#' + id + 't)', 'stroke-width': '9.5' }, line), svg);
    var shine = svgEl('path', Object.assign({ stroke: 'rgba(255,255,255,0.9)', 'stroke-width': '1.8', transform: 'translate(-0.4 -1.9)' }, line), svg);
    var loose = svgEl('path', Object.assign({ stroke: 'url(#' + id + 't)', 'stroke-width': '4.5' }, line), svg);
    var looseShadow = svgEl('path', Object.assign({ stroke: 'rgba(70,52,28,0.28)', 'stroke-width': '4.5', transform: 'translate(1 4)' }, line), svg);
    svg.insertBefore(looseShadow, loose);

    // Aguja: punta en (0,0) y el cuerpo hacia +x; el ojo es un hueco (evenodd)
    var needle = svgEl('g', {}, svg);
    var needleClip = svgEl('g', { 'clip-path': 'url(#' + id + 'c)' }, needle);
    var needleIn = svgEl('g', {}, needleClip);
    var body = 'M0,0 C20,-1.2 48,-7 78,-7 L298,-7 Q312,-7 312,0 Q312,7 298,7 L78,7 C48,7 20,1.2 0,0 Z ' +
      'M254,0 Q254,-2.4 258.5,-2.4 L285.5,-2.4 Q290,-2.4 290,0 Q290,2.4 285.5,2.4 L258.5,2.4 Q254,2.4 254,0 Z';
    var needleShadow = svgEl('path', { d: body, fill: 'rgba(13,13,12,0.3)', 'fill-rule': 'evenodd', filter: 'url(#' + id + 'b)' }, needleIn);
    svgEl('path', { d: body, fill: 'url(#' + id + 'm)', 'fill-rule': 'evenodd', stroke: 'rgba(40,42,46,0.6)', 'stroke-width': '1.1' }, needleIn);
    svgEl('path', { d: 'M30,-1.6 L246,-3.2', stroke: 'rgba(255,255,255,0.9)', 'stroke-width': '1.4', 'stroke-linecap': 'round', fill: 'none' }, needleIn);

    s.tag.appendChild(svg);
    s.st = {
      svg: svg, track: track, holes: holes, shadow: shadow, thread: thread, shine: shine,
      loose: loose, looseShadow: looseShadow,
      needle: needle, needleIn: needleIn, needleShadow: needleShadow, clipRect: clipRect,
      L: 0, N: 0, P: 0, d: 0, angle: -52, drawn: ''
    };
  }

  // Recorrido de las puntadas: justo encima de la costura que ya tiene la etiqueta FRACAZ
  // (medida en la foto de la etiqueta: 2,3 % a la izquierda, 2,8 % a la derecha, 5,1 % arriba
  // y 3,9 % abajo). Empieza arriba a la izquierda y va en el sentido de las agujas del reloj.
  function layoutStitch(s, labAR) {
    var st = s.st;
    if (!st) return;
    var VW = 1000, VH = VW / labAR, r = 12;
    var x0 = VW * 0.023, x1 = VW * (1 - 0.028), y0 = VH * 0.051, y1 = VH * (1 - 0.039);
    var d = 'M' + (x0 + r) + ',' + y0 + ' H' + (x1 - r) + ' A' + r + ',' + r + ' 0 0 1 ' + x1 + ',' + (y0 + r) +
      ' V' + (y1 - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x1 - r) + ',' + y1 +
      ' H' + (x0 + r) + ' A' + r + ',' + r + ' 0 0 1 ' + x0 + ',' + (y1 - r) +
      ' V' + (y0 + r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x0 + r) + ',' + y0;
    st.svg.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH.toFixed(2));
    [st.track, st.holes, st.shadow, st.thread, st.shine].forEach(function (p) { p.setAttribute('d', d); });
    var L = 2 * (x1 - x0 - 2 * r) + 2 * (y1 - y0 - 2 * r) + 2 * Math.PI * r;
    var N = Math.max(12, Math.round(L / 58));
    st.L = L; st.N = N; st.P = L / N; st.d = st.P * 0.66;
    st.drawn = '';
    st.box = { x0: x0, x1: x1, y0: y0, y1: y1, r: r };
  }

  // Punto del recorrido a la longitud t, calculado a mano (rectángulo de esquinas redondeadas,
  // desde arriba a la izquierda y en el sentido de las agujas del reloj): getPointAtLength en
  // cada fotograma es muy lento en móvil
  function pointAt(st, t) {
    var b = st.box, r = b.r, q = Math.PI * r / 2;
    var w = b.x1 - b.x0 - 2 * r, h = b.y1 - b.y0 - 2 * r, a;
    t = clamp(t, 0, st.L);
    if (t <= w) return { x: b.x0 + r + t, y: b.y0 };
    t -= w;
    if (t <= q) { a = -Math.PI / 2 + t / r; return { x: b.x1 - r + r * Math.cos(a), y: b.y0 + r + r * Math.sin(a) }; }
    t -= q;
    if (t <= h) return { x: b.x1, y: b.y0 + r + t };
    t -= h;
    if (t <= q) { a = t / r; return { x: b.x1 - r + r * Math.cos(a), y: b.y1 - r + r * Math.sin(a) }; }
    t -= q;
    if (t <= w) return { x: b.x1 - r - t, y: b.y1 };
    t -= w;
    if (t <= q) { a = Math.PI / 2 + t / r; return { x: b.x0 + r + r * Math.cos(a), y: b.y1 - r + r * Math.sin(a) }; }
    t -= q;
    if (t <= h) return { x: b.x0, y: b.y1 - r - t };
    t -= h;
    a = Math.PI + Math.min(t, q) / r;
    return { x: b.x0 + r + r * Math.cos(a), y: b.y0 + r + r * Math.sin(a) };
  }

  // Puntadas hechas hasta la longitud t (la última, a medias): lista para stroke-dasharray,
  // que siempre empieza por un trazo y alterna trazo/hueco. «inset» acorta cada puntada por
  // los dos lados (para el brillo, que va por dentro; se combina con stroke-dashoffset).
  function stitchDashes(st, t, inset) {
    var P = st.P, d = st.d, BIG = st.L * 2 + 10, dd = d - 2 * inset, a = [];
    var full = Math.floor(t / P), rem = t - full * P;
    for (var k = 0; k < full; k++) a.push(dd, P - dd);
    var vis = Math.min(rem, d) - inset;
    if (vis > 0.5) a.push(Math.min(vis, dd), BIG);
    else if (a.length) a[a.length - 1] = BIG;
    else return null;
    return a.map(function (v) { return v.toFixed(2); }).join(' ');
  }

  // Agujeros de la aguja (puntos) al principio y al final de cada puntada ya hecha
  function holeDashes(st, t) {
    if (t <= 0) return null;
    var a = [], P = st.P, d = st.d, BIG = st.L * 2 + 10;
    for (var k = 0; k < st.N; k++) {
      var s0 = k * P, s1 = s0 + d;
      if (s0 > t) break;
      if (k > 0) a.push(P - d - 0.01); // hueco desde el agujero anterior
      a.push(0.01); // agujero donde sale el hilo
      if (s1 > t) break;
      a.push(d - 0.01, 0.01); // y donde vuelve a entrar
    }
    a.push(BIG);
    return a.map(function (v) { return Math.max(0, v).toFixed(2); }).join(' ');
  }

  function setDash(path, list, offset) {
    if (list === null) { path.style.visibility = 'hidden'; return; }
    path.style.visibility = '';
    path.setAttribute('stroke-dasharray', list);
    if (offset) path.setAttribute('stroke-dashoffset', String(-offset));
  }

  // u: 0 → 1 dentro del tramo de costura (ya suavizado)
  function renderStitch(s, u) {
    var st = s.st;
    if (!st || !st.L) return;
    var sew = clamp((u - U_IN) / (U_OUT - U_IN), 0, 1);
    var t = sew * st.L;
    var key = t.toFixed(1) + '|' + u.toFixed(4);
    if (key === st.drawn) return;
    st.drawn = key;

    var main = stitchDashes(st, t, 0);
    setDash(st.thread, main);
    setDash(st.shadow, main);
    setDash(st.shine, stitchDashes(st, t, 7), 7);
    setDash(st.holes, holeDashes(st, t));

    // Aguja: entra desde arriba a la derecha, cose y se va por donde vino
    var come = smooth(clamp(u / U_IN, 0, 1));
    var go = smooth(clamp((u - U_OUT) / (1 - U_OUT), 0, 1));
    var away = (1 - come) * 220 + go * 260;
    var vis = come * (1 - go);
    var hp = pointAt(st, Math.min(t, st.L - 0.01));
    // Ritmo de la puntada: arriba mientras pasa el hilo por encima, hundida en el hueco
    var ph = (t % st.P) / st.P, q = st.d / st.P, dip;
    if (t >= st.L - 0.5 || sew <= 0) dip = 0;
    else if (ph <= q) dip = smooth(clamp((ph - (q - 0.12)) / 0.12, 0, 1));
    else dip = 1 - smooth(clamp((ph - 0.88) / 0.12, 0, 1));
    var ang = st.angle + 4 * dip;
    var sink = dip * 16;
    st.needle.setAttribute('transform', 'translate(' + hp.x.toFixed(2) + ' ' + hp.y.toFixed(2) + ') rotate(' + ang.toFixed(2) + ')');
    st.needleIn.setAttribute('transform', 'translate(' + (away - sink).toFixed(2) + ' 0)');
    st.clipRect.setAttribute('x', (away > 0.5 ? -400 : 0));
    st.needle.style.opacity = vis.toFixed(3);
    var rad = ang * Math.PI / 180, sx = 9 - 4 * dip, sy = 17 - 8 * dip;
    var lx = Math.cos(-rad) * sx - Math.sin(-rad) * sy, ly = Math.sin(-rad) * sx + Math.cos(-rad) * sy;
    st.needleShadow.setAttribute('transform', 'translate(' + lx.toFixed(2) + ' ' + ly.toFixed(2) + ')');

    // Hilo suelto: desde el último punto donde sale de la tela hasta el ojo de la aguja, y una cola
    if (vis > 0.01) {
      var k = Math.floor(t / st.P), inDash = (t - k * st.P) < st.d;
      var lastT = inDash ? t : k * st.P + st.d;
      var lp = sew > 0 ? pointAt(st, Math.min(lastT, st.L - 0.01)) : hp;
      var ex = 272 + away - sink, ca = Math.cos(rad), sa = Math.sin(rad);
      var exx = hp.x + ca * ex, exy = hp.y + sa * ex;
      var mx = (lp.x + exx) / 2, my = (lp.y + exy) / 2 + 26 + Math.abs(exx - lp.x) * 0.12;
      var d = 'M' + lp.x.toFixed(1) + ',' + lp.y.toFixed(1) + ' Q' + mx.toFixed(1) + ',' + my.toFixed(1) + ' ' + exx.toFixed(1) + ',' + exy.toFixed(1) +
        ' Q' + (exx + 26).toFixed(1) + ',' + (exy + 30).toFixed(1) + ' ' + (exx + 34).toFixed(1) + ',' + (exy + 92).toFixed(1);
      st.loose.setAttribute('d', d);
      st.looseShadow.setAttribute('d', d);
      st.loose.style.opacity = st.looseShadow.style.opacity = vis.toFixed(3);
    } else {
      st.loose.style.opacity = st.looseShadow.style.opacity = '0';
    }
  }

  // Etiqueta en alta: dónde está la etiqueta (la zona clara y sin color) dentro de su foto.
  // Se recorta la foto para que esa zona ocupe justo la etiqueta. Si no se puede leer o no se
  // parece a la etiqueta del interior, no se usa (la foto del interior se ve desde el principio).
  function findLabel(s) {
    var img = s.tag && s.tag.querySelector('img');
    var src = img && img.getAttribute('data-probe');
    if (!src) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.decoding = 'async';
    im.onload = function () {
      try {
        var w = 400, h = Math.max(1, Math.round(w * im.naturalHeight / im.naturalWidth));
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var g = c.getContext('2d', { willReadFrequently: true });
        g.drawImage(im, 0, 0, w, h);
        var d = g.getImageData(0, 0, w, h).data;
        var hist = new Array(256).fill(0), n = 0, i, L;
        for (i = 0; i < d.length; i += 4) {
          if (d[i + 3] > 200) { hist[Math.round(0.3 * d[i] + 0.59 * d[i + 1] + 0.11 * d[i + 2])]++; n++; }
        }
        if (!n) return;
        var acc = 0, top = 255;
        for (L = 255; L >= 0; L--) { acc += hist[L]; if (acc >= n * 0.02) { top = L; break; } }
        var thr = top * 0.78;
        var rows = new Array(h).fill(0), cols = new Array(w).fill(0);
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            i = (y * w + x) * 4;
            if (d[i + 3] <= 200) continue;
            var r = d[i], gg = d[i + 1], b = d[i + 2];
            var mx = Math.max(r, gg, b), mn = Math.min(r, gg, b);
            if (0.3 * r + 0.59 * gg + 0.11 * b >= thr && mx - mn < 70) { rows[y]++; cols[x]++; }
          }
        }
        function bounds(a) {
          var m = Math.max.apply(null, a);
          if (!m) return null;
          var lim = m * 0.3, p0 = 0, p1 = a.length - 1;
          while (p0 < p1 && a[p0] < lim) p0++;
          while (p1 > p0 && a[p1] < lim) p1--;
          return [p0, p1 + 1];
        }
        var bx = bounds(cols), by = bounds(rows);
        if (!bx || !by) return;
        var lb = { x0: bx[0] / w, x1: bx[1] / w, y0: by[0] / h, y1: by[1] / h };
        var lw = lb.x1 - lb.x0, lh = lb.y1 - lb.y0;
        if (lw < 0.2 || lh < 0.2) return;
        var a1 = (lw * im.naturalWidth) / (lh * im.naturalHeight);
        var a0 = s.lab.w * s.ar / s.lab.h;
        if (a1 / a0 > 1.3 || a0 / a1 > 1.3) return;
        img.style.width = (100 / lw).toFixed(3) + '%';
        img.style.height = (100 / lh).toFixed(3) + '%';
        img.style.left = (-lb.x0 / lw * 100).toFixed(3) + '%';
        img.style.top = (-lb.y0 / lh * 100).toFixed(3) + '%';
        s.labelOk = true;
        s.el.classList.add('is-tag-ready');
        s.last = '';
        update(s);
      } catch (e) { /* queda la foto del interior */ }
    };
    im.src = src;
  }

  // Recorte real de la mochila dentro del PNG (sin el margen transparente), en fracciones.
  function findContent(s) {
    var src = s.front.getAttribute('data-bbox-src');
    if (!src) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.decoding = 'async';
    im.onload = function () {
      try {
        var w = 160, h = Math.max(1, Math.round(w * im.naturalHeight / im.naturalWidth));
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var g = c.getContext('2d', { willReadFrequently: true });
        g.drawImage(im, 0, 0, w, h);
        var d = g.getImageData(0, 0, w, h).data;
        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            if (d[(y * w + x) * 4 + 3] > 24) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        if (x1 > x0 && y1 > y0) {
          s.cb = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h };
          measure(s);
          s.last = '';
          update(s);
        }
      } catch (e) { /* foto entera */ }
    };
    im.src = src;
  }

  // Titulares: si la palabra más larga no cabe en su zona, se reduce el cuerpo (nunca se parte).
  // Medidas de maquetación (offsetWidth), así no les afectan el zoom ni el giro de la tarjeta.
  function fitWords(el) {
    el.style.fontSize = '';
    var box = el.parentElement;
    if (!box) return;
    var bs = window.getComputedStyle(box);
    var avail = box.clientWidth - (parseFloat(bs.paddingLeft) || 0) - (parseFloat(bs.paddingRight) || 0);
    var text = (el.textContent || '').trim();
    if (avail <= 0 || !text) return;
    var probe = document.createElement('span');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;white-space:nowrap;pointer-events:none;';
    el.appendChild(probe);
    var widest = 0;
    text.split(/\s+/).forEach(function (w) {
      probe.textContent = w;
      if (probe.offsetWidth > widest) widest = probe.offsetWidth;
    });
    el.removeChild(probe);
    if (widest > avail) {
      var fs = parseFloat(window.getComputedStyle(el).fontSize) || 0;
      if (fs) el.style.fontSize = (fs * avail / widest * 0.97).toFixed(2) + 'px';
    }
  }

  function measure(s) {
    var pr = s.pin.getBoundingClientRect();
    var PW = pr.width, PH = pr.height;
    if (!PW || !PH) { s.geo = null; return; }
    var cb = s.cb, cw = cb.x1 - cb.x0, ch = cb.y1 - cb.y0;
    var mobile = PW < 750;
    // Foto entera: la mochila centrada, casi a toda la altura (debajo del marcador)
    var top = Math.max(PH * 0.075, 40), bottom = PH * (mobile ? 0.05 : 0.06);
    var bw = PW * (mobile ? 0.9 : 0.86), bh = PH - top - bottom;
    var car = s.ar * cw / ch;
    var contW = Math.min(bw, bh * car), contH = contW / car;
    var W = contW / cw, H = W / s.ar;
    var F = { x: (PW - contW) / 2 - cb.x0 * W, y: top + (bh - contH) / 2 - cb.y0 * H, w: W, h: H };

    // Al empezar, la etiqueta ocupa buena parte de la pantalla
    var lab = s.lab;
    var labAR = (lab.w * W) / (lab.h * H);
    var target = mobile ? Math.min(PW * 0.9, PW * s.size * 1.6) : PW * s.size;
    target = Math.min(target, PH * (mobile ? 0.5 : 0.62) * labAR);
    var z0 = Math.max(1.2, target / (lab.w * W));

    // Tamaño base de la tarjeta = la foto entera a escala 1
    s.card.style.width = W + 'px';
    s.card.style.height = H + 'px';
    if (s.back) {
      if (s.cutout && s.strapAr) {
        // Correas sin fondo: la foto entera, centrada sobre el mismo eje de giro (el centro de la
        // mochila, que al terminar el zoom está en el centro de la pantalla). En ordenador, a la
        // altura de la mochila; en móvil, a todo el ancho de la pantalla, de borde a borde.
        var bhPx, bwPx;
        if (mobile) {
          bwPx = PW; bhPx = bwPx / s.strapAr;
          var maxH = PH * 0.9;
          if (bhPx > maxH) { bhPx = maxH; bwPx = bhPx * s.strapAr; }
        } else {
          bhPx = ch * H; bwPx = bhPx * s.strapAr;
          if (bwPx > PW * 0.86) { bwPx = PW * 0.86; bhPx = bwPx / s.strapAr; }
        }
        var bx = (cb.x0 + cb.x1) / 2 * W - bwPx / 2;
        var by = (cb.y0 + cb.y1) / 2 * H - bhPx / 2;
        s.back.style.left = (bx / W * 100) + '%';
        s.back.style.top = (by / H * 100) + '%';
        s.back.style.width = (bwPx / W * 100) + '%';
        s.back.style.height = (bhPx / H * 100) + '%';
      } else {
        s.back.style.left = (cb.x0 * 100) + '%';
        s.back.style.top = (cb.y0 * 100) + '%';
        s.back.style.width = (cw * 100) + '%';
        s.back.style.height = (ch * 100) + '%';
      }
    }
    var ox = ((cb.x0 + cb.x1) / 2 * 100).toFixed(3) + '% ' + ((cb.y0 + cb.y1) / 2 * 100).toFixed(3) + '%';
    s.front.style.transformOrigin = ox;

    // La aparición de la mochila: un círculo que crece desde la etiqueta hasta cubrir la foto
    var lcx = lab.x + lab.w / 2, lcy = lab.y + lab.h / 2;
    var r0 = Math.sqrt(Math.pow(lab.w * W / 2, 2) + Math.pow(lab.h * H / 2, 2));
    var r1 = 0;
    [[0, 0], [1, 0], [0, 1], [1, 1]].forEach(function (c) {
      r1 = Math.max(r1, Math.sqrt(Math.pow((c[0] - lcx) * W, 2) + Math.pow((c[1] - lcy) * H, 2)));
    });

    s.geo = {
      PW: PW, PH: PH, F: F, z0: z0, labAR: labAR,
      persp: Math.max(900, contW * 2.6),
      lcx: lcx, lcy: lcy, r0: r0, r1: r1
    };

    // La etiqueta grande tiene siempre su tamaño de partida (el mayor) y se encoge con transform:
    // así no se recoloca ni se repinta en cada fotograma
    if (s.tag) {
      s.tag.style.width = (lab.w * W * z0).toFixed(2) + 'px';
      s.tag.style.height = (lab.h * H * z0).toFixed(2) + 'px';
    }
    // Velo: un cuadrado centrado en la etiqueta, del color del fondo, con un hueco redondo
    if (s.veil) {
      var col = window.getComputedStyle(s.pin).backgroundColor || '';
      if (!col || col === 'rgba(0, 0, 0, 0)' || col === 'transparent') col = window.getComputedStyle(s.el).backgroundColor || '#e8e4da';
      if (col !== s.veilColor) {
        s.veilColor = col;
        s.veil.style.setProperty('--fz-veil', col);
      }
      var S = r1 * 2;
      // El hueco más pequeño (al empezar) tiene que dejar el velo tapando toda la foto
      var hole = Math.min(VEIL_HOLE, (r0 * 0.55) / (r1 * 1.05));
      s.veil.style.setProperty('--fz-veil-hole', (hole * 100).toFixed(3) + '%');
      s.veil.style.setProperty('--fz-veil-soft', (hole * 72).toFixed(3) + '%');
      s.veil.style.width = s.veil.style.height = S.toFixed(1) + 'px';
      s.veil.style.left = (lcx * W - S / 2).toFixed(1) + 'px';
      s.veil.style.top = (lcy * H - S / 2).toFixed(1) + 'px';
      s.geo.veilS = S;
      s.geo.veilHole = hole;
    }
    if (s.st) layoutStitch(s, labAR);
    Array.prototype.forEach.call(s.titles, fitWords);
  }

  function progress(s) {
    var r = s.el.getBoundingClientRect();
    var top = parseFloat(window.getComputedStyle(s.pin).top) || 0;
    var dist = r.height - s.pin.offsetHeight;
    // antes de quedarse fija: cuánto le falta a la escena para llegar arriba (en pantallas)
    s.pre = r.top > top ? (r.top - top) / Math.max(1, window.innerHeight) : 0;
    return dist > 0 ? clamp((top - r.top) / dist, 0, 1) : 1;
  }

  // Progreso que se ve (s.pS): persigue al del scroll (s.pT); frame lo avanza en cada fotograma.
  // read: frame ya ha leído el scroll; si no, se lee aquí.
  function update(s, read) {
    var g = s.geo;
    if (!g) return;
    if (!read) {
      s.pT = progress(s);
      if (s.pS === undefined) s.pS = s.pT;
      if (s.pS !== s.pT) request();
    }
    var p = s.pS;
    var still = reduce.matches;
    var key = p.toFixed(4) + '|' + s.pre.toFixed(3) + (still ? 'r' : '') + (s.labelOk ? 'l' : '') + (s.tagLoaded ? 't' : '') + (s.st ? '|' + s.uShown.toFixed(3) : '');
    if (key === s.last) return;
    s.last = key;
    var T = s.T, F = g.F;
    var tagOn = s.labelOk && s.tagLoaded && !still && s.tag;

    // 1–2. Zoom hacia atrás: la etiqueta, de grande a su sitio (escala geométrica: velocidad constante)
    var tz = still ? 1 : seg(p, T.zoom);
    var ez = easeInOut(tz);
    var k = Math.pow(g.z0, 1 - ez);
    var w = F.w * k, h = F.h * k;
    var endX = F.x + g.lcx * F.w, endY = F.y + g.lcy * F.h;
    var m = smooth(ez);
    var cx = g.PW / 2 + (endX - g.PW / 2) * m;
    var cy = g.PH / 2 + (endY - g.PH / 2) * m;

    // 4. Giro: se aleja un poco a mitad de vuelta, como al girar algo en la mano
    var tf = T.flip && !still ? easeInOut(seg(p, T.flip)) : 0;
    var dip = 1 - 0.07 * Math.sin(Math.PI * tf);
    var x = cx - g.lcx * w, y = cy - g.lcy * h;
    if (dip !== 1) {
      var mx = x + (s.cb.x0 + s.cb.x1) / 2 * w, my = y + (s.cb.y0 + s.cb.y1) / 2 * h;
      w *= dip; h *= dip;
      x = mx - (s.cb.x0 + s.cb.x1) / 2 * w;
      y = my - (s.cb.y0 + s.cb.y1) / 2 * h;
    }
    var sc = w / F.w;
    s.card.style.transform = 'translate(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px) scale(' + sc.toFixed(4) + ')';

    // La mochila aparece alrededor de la etiqueta: un hueco redondo que crece desde ella en un
    // velo del color del fondo (solo se escala: no hay que repintar la foto en cada fotograma)
    var rv = tagOn ? seg(p, T.reveal) : 1;
    if (s.veil && g.veilS) {
      if (rv >= 1) {
        s.veil.style.visibility = 'hidden';
      } else {
        var er = easeOut(rv);
        var R = g.r0 * 0.55 + (g.r1 * 1.1 - g.r0 * 0.55) * er;
        var vs = R / (g.veilHole * g.veilS / 2);
        s.veil.style.visibility = 'visible';
        s.veil.style.transform = 'scale(' + vs.toFixed(4) + ')';
      }
    }

    // La etiqueta nítida, fuera del zoom: siempre encima de la de la foto, a su tamaño real.
    // Llega levantada desde la lluvia y se asienta; al final del zoom se funde con la de la foto.
    if (s.tag) {
      if (tagOn) {
        var lift = smooth(clamp(s.pre / 0.7, 0, 1));
        var lx = x + s.lab.x * F.w * sc, ly = y + s.lab.y * F.h * sc;
        // No se funde con la de la foto hasta que la aguja ha terminado
        var sewnK = s.st ? smooth(clamp((s.uShown - 0.9) / 0.1, 0, 1)) : 1;
        var fadeOut = smooth(clamp((tz - 0.82) / 0.18, 0, 1)) * sewnK;
        var under = 1 - smooth(rv);
        s.tag.style.transform = 'translate3d(' + lx.toFixed(2) + 'px,' + ly.toFixed(2) + 'px,0) scale(' + (sc / g.z0).toFixed(5) + ')' +
          (lift > 0.001 ? ' translateY(' + (-7 * lift).toFixed(3) + '%) translate(50%,50%) rotate(' + (-5.5 * lift).toFixed(3) + 'deg) scale(' + (1 + 0.07 * lift).toFixed(4) + ') translate(-50%,-50%)' : '');
        s.tag.style.opacity = (1 - fadeOut).toFixed(3);
        s.tag.style.visibility = fadeOut >= 1 || tf > 0 ? 'hidden' : 'visible';
        // Sombra: dos sombras fijas (apoyada y levantada) que se funden
        setOpacity(s.shRest, under * (1 - lift));
        setOpacity(s.shLift, under * lift);
      } else {
        s.tag.style.visibility = 'hidden';
      }
    }

    // Costura: lo que se ve persigue al scroll (suavizado en stitchFrame)
    if (s.st) {
      s.uTarget = seg(p, T.stitch);
      s.stFade = tagOn ? 1 : 0;
    }

    // 3. Texto del interior encima de la tapa
    var ti = seg(p, T.textIn);
    if (s.text) {
      s.text.style.opacity = easeOut(ti).toFixed(3);
      s.text.style.transform = 'translate3d(0,' + ((1 - easeOut(ti)) * 1.2).toFixed(3) + 'rem,0)';
    }
    if (s.facts) {
      var out = T.flip ? seg(p, [T.flip[0], T.flip[0] + 0.05]) : 0;
      s.facts.style.opacity = (easeOut(ti) * (1 - out)).toFixed(3);
    }

    // 4. Las dos caras (3D solo mientras gira: así la foto se repinta nítida durante el zoom)
    var backOn = false;
    if (s.back && T.flip) {
      if (still) {
        var cf = seg(p, T.flip);
        s.front.style.opacity = (1 - cf).toFixed(3);
        s.back.style.opacity = cf.toFixed(3);
        s.front.style.transform = s.back.style.transform = 'none';
        s.back.style.visibility = cf > 0 ? 'visible' : 'hidden';
        s.front.style.visibility = cf < 1 ? 'visible' : 'hidden';
        backOn = cf > 0.5;
      } else {
        var ang = 180 * tf;
        backOn = ang > 90;
        s.front.style.opacity = s.back.style.opacity = '';
        if (tf <= 0) {
          s.front.style.transform = s.back.style.transform = '';
        } else {
          var pp = 'perspective(' + g.persp.toFixed(0) + 'px) ';
          s.front.style.transform = pp + 'rotateY(' + ang.toFixed(2) + 'deg)';
          s.back.style.transform = pp + 'rotateY(' + (ang - 180).toFixed(2) + 'deg)';
        }
        s.front.style.visibility = backOn ? 'hidden' : 'visible';
        s.back.style.visibility = backOn ? 'visible' : 'hidden';
      }
      if (s.strapText) {
        var ts = seg(p, T.strapIn);
        s.strapText.style.opacity = easeOut(ts).toFixed(3);
        s.strapText.style.transform = 'translate3d(0,' + ((1 - easeOut(ts)) * 1.2).toFixed(3) + 'rem,0)';
      }
    }

    // Marcador: oculto mientras se cose; luego el zoom y, al girar, los grados
    s.hudSew = !!(s.st && tagOn && p < T.stitch[1] && tz < 0.9);
    if (s.hudBox) s.hudBox.style.opacity = s.hudSew ? '0' : '';
    if (s.hud) {
      var side = backOn ? 'b' : 'a';
      if (side !== s.hudSide) {
        s.hudSide = side;
        s.hud.textContent = side === 'b' ? (s.hud.getAttribute('data-fz-inside-hud-back') || '') : s.hud.getAttribute('data-fz-inside-hud');
      }
    }
    if (s.value) {
      var hv = tf > 0 ? Math.round(180 * tf) + '°' : '× ' + k.toFixed(1);
      if (hv !== s.hudText) { s.hudText = hv; s.value.textContent = hv; }
    }
  }

  // Costura suavizada: lo que se ve persigue al scroll (sin saltos con la rueda del ratón)
  function stitchFrame(s, now) {
    if (!s.st) return false;
    var dt = s.uTime ? Math.min(0.1, (now - s.uTime) / 1000) : 0.016;
    s.uTime = now;
    var diff = s.uTarget - s.uShown;
    if (Math.abs(diff) < 0.0004) s.uShown = s.uTarget;
    else {
      var step = diff * (1 - Math.exp(-dt / ST_LAG));
      var cap = ST_MAX * dt;
      s.uShown += step > cap ? cap : step < -cap ? -cap : step;
    }
    // Al rematar la última puntada, la etiqueta da un pequeño tirón (se repite si se vuelve atrás)
    var sewn = s.uShown >= U_OUT;
    if (sewn !== s.sewn) {
      s.sewn = sewn;
      s.tag.classList.toggle('is-sewn', sewn);
    }
    if (s.stFade > 0) {
      s.st.svg.style.visibility = 'visible';
      renderStitch(s, s.uShown);
    } else {
      s.st.svg.style.visibility = 'hidden';
    }
    return s.uShown !== s.uTarget;
  }

  function followP(s, now) {
    if (s.pT === undefined) return false;
    var dt = s.pTime ? Math.min(0.1, (now - s.pTime) / 1000) : 0.016;
    s.pTime = now;
    var d = s.pT - s.pS;
    if (Math.abs(d) < 0.0005) { s.pS = s.pT; return false; }
    var step = d * (1 - Math.exp(-dt / P_LAG)), cap = P_MAX * dt;
    s.pS += step > cap ? cap : step < -cap ? -cap : step;
    return true;
  }

  function frame(now) {
    ticking = false;
    var again = false;
    now = now || performance.now();
    for (var i = 0; i < scenes.length; i++) {
      var s = scenes[i];
      if (!s.el.isConnected) { scenes.splice(i--, 1); continue; }
      if (s.near) {
        // Primero se lee (dónde va el scroll) y luego se escribe: sin recolocar la página dos veces
        if (s.geo) {
          s.pT = progress(s);
          if (s.pS === undefined || reduce.matches) s.pS = s.pT;
          else if (followP(s, now)) again = true;
        }
        update(s, true);
        if (stitchFrame(s, now)) again = true;
      } else {
        s.uTime = 0;
        s.pTime = 0;
      }
    }
    if (again) { moving(); request(); }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(frame);
  }

  function remeasureAll() {
    scenes.forEach(function (s) { measure(s); s.last = ''; update(s); });
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-fz-inside]'), setup);
  }

  // Mientras hay movimiento (scroll o la aguja cosiendo), la tarjeta y la etiqueta van en su
  // propia capa (se mueven sin repintar las fotos); al parar, se quita y el navegador las vuelve
  // a pintar nítidas a su tamaño
  var idleT = 0, lastMove = 0;
  function settle() {
    var wait = 220 - (performance.now() - lastMove);
    if (wait > 10) { idleT = setTimeout(settle, wait); return; }
    idleT = 0;
    scenes.forEach(function (s) { if (s.moving) { s.moving = 0; s.pin.classList.remove('is-moving'); } });
  }
  function moving() {
    lastMove = performance.now();
    for (var i = 0; i < scenes.length; i++) {
      var s = scenes[i];
      if (s.near && !s.moving) { s.moving = 1; s.pin.classList.add('is-moving'); }
    }
    if (!idleT) idleT = setTimeout(settle, 220);
  }
  function onScroll() {
    moving();
    request();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { scenes.forEach(function (s) { s.last = ''; }); request(); });
  if (reduce.addEventListener) reduce.addEventListener('change', remeasureAll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', remeasureAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasureAll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
